import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-bg-primary text-white selection:bg-accent-blue selection:text-white relative overflow-hidden">
      {/* Subtle background glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(59,130,246,0.1),transparent_50%)] pointer-events-none" />
      
      <div className="relative z-10 flex flex-col items-center justify-center space-y-6">
        {/* Animated Logo Container */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          className="relative w-28 h-28 md:w-32 md:h-32 flex items-center justify-center"
        >
          {/* Pulsing ring behind the logo */}
          <motion.div
            className="absolute inset-0 rounded-full border-2 border-accent-blue/30"
            animate={{ 
              scale: [1, 1.2, 1],
              opacity: [0.5, 0, 0.5]
            }}
            transition={{ 
              duration: 2, 
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
          
          {/* The Actual Logo */}
          <motion.img
            src="/assets/motion/screen.png"
            alt="CloudYatra Loading"
            className="w-full h-full object-contain relative z-10"
            animate={{ 
              y: [0, -8, 0] 
            }}
            transition={{ 
              duration: 3, 
              repeat: Infinity,
              ease: "easeInOut" 
            }}
          />
        </motion.div>
        
        {/* Loading Text */}
        <motion.div 
          className="flex flex-col items-center"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <div className="flex items-center gap-1">
            <span className="text-lg font-medium tracking-wide text-white/90">Initializing System</span>
            <motion.span
              animate={{ opacity: [0, 1, 0] }}
              transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
              className="text-accent-blue font-bold"
            >
              ...
            </motion.span>
          </div>
          
          {/* Loading bar */}
          <div className="w-48 h-1 bg-white/10 rounded-full mt-4 overflow-hidden relative">
            <motion.div 
              className="absolute top-0 bottom-0 left-0 bg-accent-blue"
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ 
                duration: 2, 
                ease: "easeInOut",
                repeat: Infinity,
                repeatType: "reverse"
              }}
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LoadingScreen;
